<script setup lang="ts">
import { reactive } from 'vue'
import { useRegisterSW } from 'virtual:pwa-register/vue'

const { needRefresh, updateServiceWorker } = useRegisterSW()

const TOAST_ANIMATION_DURATION = 500
const toastClasses = reactive({
  toast: true,
  hidden: false,
})

const update = () => {
  toastClasses.hidden = true
  updateServiceWorker()
}
const close = () => {
  toastClasses.hidden = true
  setTimeout(() => (needRefresh.value = false), TOAST_ANIMATION_DURATION) // Timeout to let toast hide
}
</script>

<template>
  <div v-if="needRefresh" :class="toastClasses" role="alert">
    <div class="message">Nouvelle version de l'application disponible.</div>
    <button @click="update">Recharger</button>
    <button @click="close">Fermer</button>
  </div>
</template>

<style scoped lang="scss">
.toast {
  --animation-duration: calc(v-bind(TOAST_ANIMATION_DURATION) * 1ms);
  position: fixed;
  right: 0;
  bottom: 0;
  margin: 16px;
  padding: 12px;
  color: white;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.85);
  box-shadow: 3px 4px 5px 0 #8885;
  border: 1px solid #8885;
  border-radius: 4px;
  animation: slide-up ease-in-out var(--animation-duration);
  z-index: 1000;

  &.hidden {
    transform: translateY(150%);
    transition: transform ease-in-out var(--animation-duration);
  }

  .message {
    margin-bottom: 8px;
  }
  button {
    margin-right: 5px;
    padding: 3px 10px;
    border: 1px solid #8885;
    border-radius: 2px;
    outline: none;
  }

  @keyframes slide-up {
    0% {
      transform: translateY(150%);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
